import React, { useState, useEffect } from 'react';
import "./construction.css";
import Sidebar from '../../../Components/Sidebar/Sidebar';
import construct1 from "../../../Assets/construction-site.jpg"
import { Link } from 'react-router';
import construct2 from "../../../Assets/sound-barrier-india.webp";
import construct3 from "../../../Assets/const-2.png";
import construct4 from "../../../Assets/sound-barrier-manufacturer.webp";
import construct5 from "../../../Assets/const-sites/cs-r1.jpg";
import construct6 from "../../../Assets/const-sites/cs-r2.jpg";
import construct7 from "../../../Assets/const-sites/cs-r3.jpg";
import construct8 from "../../../Assets/const-sites/cs-r4.jpg";
import construct9 from "../../../Assets/const-sites/cs-r5.jpg";
import construct10 from "../../../Assets/const-sites/cs-r6.jpg";
import construct11 from "../../../Assets/const-sites/cs-r7.jpg";
import HNavbar from '../../../Components/Navbar/HNavbar';
import MFooter from '../../../Components/Main-Footer/MFooter';

function ConstructionSites() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    const handleClick = () => {
        const name = document.getElementById('name').value.trim();
        const mail = document.getElementById('mail').value.trim();
        const phone = document.getElementById('phone').value.trim();
        const message = document.getElementById('message').value.trim();

        const subject = `New message from ${name}`
        const body = `Name: ${name}%0AEmail: ${mail}%0APhone: ${phone}%0A%0AMessage:%0A${message}`;
        const mailtoLink = `mailto:mail@acousticalsurfaces.in?subject=${encodeURIComponent(subject)}&body=${body}`;

        window.open(mailtoLink, '_blank');

        document.getElementById('name').value = '';
        document.getElementById('mail').value = '';
        document.getElementById('phone').value = '';
        document.getElementById('message').value = '';
    }
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    useEffect(() => {
        const animatedElements = document.querySelectorAll('.site-header,.site-header-sub,.site-header1,.site-header2,.site-header3,.site-header4,.site-header5,.site-header6');

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate');
                } else {
                    entry.target.classList.remove('animate');
                }
            });
        }, { threshold: 0.3 });

        animatedElements.forEach(el => observer.observe(el));

        return () => {
            animatedElements.forEach(el => observer.unobserve(el));
        };
    }, []);

    return (
        <>
        <HNavbar />
            <section id='construction-site' className='home-construction'>
                <div className='container p-0'>
                    <Sidebar />
                    <div className='row main-const'>
                        <div className='col-12 col-md-6 d-flex justify-content-center align-items-center p-3'>
                            <div className='image-wrapper'>
                                <img className='img-fluid const-home-img' src={construct1} alt="construction site" />
                            </div>
                        </div>
                        <div className='col-12 col-md-6 d-flex flex-column justify-content-center align-items-start'>
                            <h1 className='site-header'>Construction Site</h1>
                            <h1 className='site-header-sub'>Noise Control Solutions</h1>
                            <p className='white-para'>Construction activities generate high noise levels that can disturb
                                nearby residential and commercial areas. Sound Barrier Manufacture
                                provides advanced construction site noise control solutions using
                                high-performance sound barrier blankets and temporary acoustic
                                enclosures to minimize public disturbance.</p>
                            <p className='white-para'>Our construction sound barriers are specially designed to reduce
                                noise pollution, comply with local regulations, and maintain a safer
                                working environment.</p>
                            <Link to="/contact"><button className='btn' type="button">Contact us</button></Link>
                        </div>
                    </div>
                </div>
            </section >
            <section id='construction-site'>
                <div className='container noice-control mt-4 p-3'>
                    <h1 className='site-header1'>What is Construction Site Noise Control?</h1>
                    <p>Construction site noise control involves installing temporary sound barrier systems around active

                        work zones to reduce the transmission of noise to surrounding areas.</p>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6 d-flex justify-content-center'>
                            <img className='img-fluid' src={construct2} alt="construction site2" />
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex flex-column align-items-center justify-content-center'>
                            <h4>Our sound barrier blankets are used to:</h4>
                            <ul className='list'>
                                <li>Block heavy machinery noise</li>
                                <li>Reduce drilling and piling sound</li>
                                <li>Control demolition noise</li>
                                <li>Protect nearby residential communities</li>
                                <li>Maintain regulatory compliance</li>
                            </ul>
                        </div>
                    </div>

                    <h1 className='site-header2' style={{ marginTop: "10px" }}>Our Construction Sound Barrier System</h1>
                    <p>Sound Barrier Manufacture supplies high-density sound blankets and

                        temporary noise barriers for construction projects.</p>
                    <div className='row mt-5 justify-content-center'>
                        <div className='col-sm-12 col-md-6 d-flex justify-content-center align-items-center'>
                            <div className='feature-box'>
                                <h5>Key Features:</h5>
                                <ul className='list'>
                                    <li>High STC-rated sound barrier material</li>
                                    <li>Durable weather-resistant outer layer</li>
                                    <li>Easy installation on fencing or scaffolding</li>
                                    <li>Reusable and long-lasting material</li>
                                    <li>Fire-retardant options available</li>
                                    <li>Suitable for outdoor environments</li>
                                </ul>
                            </div>
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex justify-content-center align-items-center'>
                            <img className='img-fluid' src={construct3} alt="const site" style={{ height: "400px", width: "350px" }} />
                        </div>
                    </div>

                    <h1 className='site-header3' style={{ marginTop: "30px" }}>Benefits of Using Sound Barriers at Construction Sites</h1>
                    <p>Installing construction noise barriers helps:</p>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6 d-flex justify-content-center'>
                            <img className='img-fluid' src={construct4} alt="construction site2" />
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex justify-content-center align-items-center'>
                            <ul className='list'>
                                <li>Reduce noise pollution outside the project area</li>
                                <li>Prevent public disturbance complaints</li>
                                <li>Meet environmental noise regulations</li>
                                <li>Improve company reputation</li>
                                <li>Protect workers from excessive sound exposure</li>
                            </ul>
                        </div>
                    </div>
                    <h1 className='site-header4' style={{ marginTop: "20px" }}>Applications</h1>
                    <h4 className='sub-title mt-3'>Our construction noise control solutions are ideal for:</h4>
                    <div className='row'>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={construct5} alt="construction site2" />
                            <p className=''>Residential construction projects</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={construct6} alt="construction site2" />
                            <p>Commercial building sites</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={construct7} alt="construction site2" />
                            <p>Infrastructure projects</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={construct8} alt="construction site2" />
                            <p>Road and bridge construction</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={construct9} alt="construction site2" />
                            <p>Metro and railway projects</p>
                        </div>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={construct10} alt="construction site2" />
                            <p>Demolition sites</p>
                        </div>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={construct11} alt="construction site2" />
                            <p>Corporate offices</p>
                        </div>
                    </div>
                </div>
            </section>
            <section id='construction-site' className='call'>
                <div className='container'>
                    <h1 className='site-header5'>Why Choose Us?</h1>
                    <p className='end-content1 white-para'>We understand the importance of controlling outdoor construction

                        noise without affecting project progress.</p>

                    <ul className='contact-list white-para'>
                        <li>Experienced acoustic solution provider</li>
                        <li>High-performance construction sound blankets</li>
                        <li>Custom size and thickness options</li>
                        <li>Fast supply and installation support</li>
                        <li>Cost-effective temporary noise control systems</li>
                    </ul>

                    <h1 className='site-header6'>Get Reliable Construction Site Noise Control Today!</h1>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6 mt-3 p-0'>
                            <p className='end-content1 white-para'>Looking for effective noise control solutions for your construction site?</p>
                            <p className='end-content1 white-para'>Sound Barrier Manufacture offers professional sound barrier systems designed to<br /> reduce public disturbance and improve environmental compliance.</p>
                            <p className='end-content1 white-para'>Contact us today for expert consultation and site-specific noise control solutions.</p>
                        </div>
                        <div className='col-sm-12 col-md-6 p-0'>
                            <div className="row">
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="text"
                                        name="name"
                                        id="name"
                                        className="form-control"
                                        placeholder="Name *"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="email"
                                        name="mail"
                                        id="mail"
                                        className="form-control"
                                        placeholder="Email *"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="text"
                                        name="phone"
                                        id="phone"
                                        className="form-control"
                                        placeholder="Phone *"
                                    />
                                </div>
                                <div className="col-12 mb-3">
                                    <textarea
                                        rows={4}
                                        id="message"
                                        className="form-control"
                                        placeholder="Message *"
                                    ></textarea>
                                </div>
                                <div className="col-12">
                                    <button
                                        className="btn"
                                        type="button"
                                        onClick={handleClick}
                                    >
                                        SEND
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {showTopBtn && (
                <button className='scroll-to-top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                > ↑ </button>
            )}
            <MFooter />
        </>
    )
}

export default ConstructionSites